import i18next from 'i18next'

export const translate = (obj) => {
	const currentLang = i18next.language
	if (!obj.hasOwnProperty(currentLang)) return null
	return obj[currentLang]
}

export const getLang = () => {
    return i18next.language
}



// WEBPACK FOOTER //
// ./src/utils/translate.js